import Firebase from 'firebase';
import Immutable from 'immutable';

const config = {
    apiKey: "AIzaSyCvO-4G6WQ8K12LgLA7H0jU-_2BGcXNE70",
    authDomain: "live-results-e39dc.firebaseapp.com",
    databaseURL: "https://live-results-e39dc.firebaseio.com",
    storageBucket: "live-results-e39dc.appspot.com",
};
export const firebase = Firebase.initializeApp(config);
export const db = firebase.database();
export const auth = firebase.auth();

export function firebaseStartListeners(store) {
    let initialLoad = false;

    function userUpdate(snapshot) {
        const val = snapshot.val();
        setTimeout(() => {
            store.dispatch({type: 'setFavourites', favourites: Object.keys(val.favourites)});
            store.dispatch({type: 'setUserRoles', roles: Object.keys(val.roles || {})});
        });
    }

    db.ref('schedule').on('value', snapshot => {
        initialLoad = true;

        const {venues, events, entries} = snapshot.val();

        store.dispatch({type: 'dataLoad', venues, events, entries});
        db.ref('schedule').off('value');
    });

    db.ref('schedule/entries').on('child_changed', snapshot => {
        if (!initialLoad) {
            return;
        }
        store.dispatch({type: 'entryChanged', entry: snapshot.val()});
    });

    auth.onAuthStateChanged(user => {
        if (user) {
            const uid = user.uid;
            const name = user.displayName;
            const email = user.email;

            store.dispatch({
                type: "login",
                uid, name,
            });

            const userRef = db.ref(`/users/${uid}`);

            userRef.update({name, email});

            userRef.off();

            userRef.on('value', userUpdate);
        }
        else {
            store.dispatch({type: "logout"});
        }
    });
}



/** WEBPACK FOOTER **
 ** ./src/firebase.js
 **/